<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>

    <!-- <v-card> -->
    <v-row dense
           class="d-flex mx-16">
      <!-- <v-col cols="12">
          <v-tabs vertical
                  center-active
                  background-color="grey lighten-5">
            <v-tab>
              <span class="font-weight-bold">Basic Information</span>
            </v-tab>
            <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Samples</span>
            </v-tab>
            <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Differential Expression Genes</span>
            </v-tab>
            <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Differential Splicing Events</span>
            </v-tab>
            <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Differential Transcript Usage</span>
            </v-tab>
            <v-divider></v-divider>
            <v-tab>
              <span class="font-weight-bold">Isoform Switching</span>
            </v-tab>

            <v-tab-item>
              <v-col cols="12">
                <div class="ml-4">
                  <h3>
                    {{$route.params.id}}
                  </h3>
                </div>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">
                      Project Name:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <div class="v-item-group">
                        <v-btn class="mx-1"
                               small
                               outlined
                               color="success">{{project_meta.project_name}}</v-btn>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">
                      Primary Site:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <div class="v-item-group">
                        <v-btn class="mx-1"
                               small
                               outlined
                               color="success">{{project_meta.primary_site}}</v-btn>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">
                      Disease Type:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <div class="v-item-group"
                           v-for="(disease, index) in project_meta.disease_type && project_meta.disease_type.split('; ')"
                           :key="index">
                        <v-btn class="mx-1"
                               small
                               outlined
                               color="success">{{disease}}</v-btn>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">
                      Tumor / Normal:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{project_meta.tumor_no}} / {{project_meta.normal_no}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </v-col>
            </v-tab-item>
            <v-tab-item>
            </v-tab-item>
            <v-tab-item>
              <v-col cols="12">
                <v-tabs>
                  <v-tab>DEG Heatmap</v-tab>
                  <v-tab>Up Regulated Genes</v-tab>
                  <v-tab>Down Regulated Genes</v-tab>
                  <v-tab-item>Heatmap</v-tab-item>
                  <v-tab-item>Up Regulated Genes Tables</v-tab-item>
                  <v-tab-item>Down Regulated Genes Tables</v-tab-item>
                </v-tabs>
              </v-col>
            </v-tab-item>
            <v-tab-item>
              <v-col cols="12">
                <v-tabs>
                  <v-tab>rMATS</v-tab>
                  <v-tab>SUPPA2</v-tab>
                  <v-tab>SplAdder</v-tab>
                  <v-tab-item>rMATS DASE Table</v-tab-item>
                  <v-tab-item>SUPPA2 DASE Table</v-tab-item>
                  <v-tab-item>SplAdder DASE Table</v-tab-item>
                </v-tabs>
              </v-col>
            </v-tab-item>
            <v-tab-item>
              <v-col cols="12">
                Differential Transcript Usage
              </v-col>
            </v-tab-item>
            <v-tab-item>
              <v-col cols="12">
                IsoformSwitchAnalyzeR
                <v-img src="../../assets/img/IsoformSwitchR.png"></v-img>
              </v-col>
            </v-tab-item>
          </v-tabs>
        </v-col> -->

      <v-col cols="12"
             sm="12"
             md="12"
             lg="12"
             class="mt-2">
        <!-- download function -->
        <div class="my-3"
             v-if="selected.length > 0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="success"
                     dark
                     v-bind="attrs"
                     v-on="on"
                     rounded
                     small
                     class="ml-2">
                <span class="font-weight-bold">Download</span>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="xls"
                              :data="selected"
                              :name="$route.params.id + '-Meta.xls'">
                    <v-btn text
                           block> <span class="font-weight-bold">xls</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="csv"
                              :data="selected"
                              :name="$route.params.id + '-Meta.csv'">
                    <v-btn text
                           block> <span class="font-weight-bold">csv</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-expansion-panels class="data-table-style">
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down"
                                      style="padding: 10px 25px">
              <div class="d-flex font-weight-bold">
                <span class="blue--text font-weight-bold mt-1">Display Columns</span>
                <v-chip outlined
                        small
                        color="success"
                        class="ml-2"
                        @click="showAll()">
                  Select All
                </v-chip>
                <v-chip outlined
                        small
                        color="error"
                        class="ml-2"
                        @click="showDefault()">
                  Select Default
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="v-item-group">
                <v-checkbox v-for="(header, index) in headers"
                            :key="index"
                            :label="header.text"
                            :value="header.text"
                            v-model="selectedHeader"
                            dense
                            class="mx-1"></v-checkbox>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-data-table dense
                      v-model="selected"
                      class="data-table-style mt-1"
                      :headers="selectedHeaders"
                      fixed-header
                      :items="project_samples"
                      item-key="ID"
                      :search="search"
                      show-select
                      :single-select="singleSelect"
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      :items-per-page="itemsPerPage"
                      :footer-props="{
      showFirstLastPage: true,
      firstIcon: 'mdi-page-first',
      lastIcon: 'mdi-page-last',
      'items-per-page-options':[5,10,15,20,50,100,-1] }"
                      v-show="selectedHeaders && selectedHeaders.length > 0">
          <!-- header.status slot -->
          <template v-slot:[`header.status`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>1: Dead <br>0: Live</span>
            </v-tooltip>
          </template>
          <!-- header.time slot -->
          <template v-slot:[`header.time`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Unit: Day</span>
            </v-tooltip>
          </template>
          <!-- header.DFI slot -->
          <template v-slot:[`header.DFI`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>1: Dead <br>0: Live</span>
            </v-tooltip>
          </template>
          <!-- header.DFI.time slot -->
          <template v-slot:[`header.DFI.time`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Unit: Day</span>
            </v-tooltip>
          </template>
          <!-- header.DSS slot -->
          <template v-slot:[`header.DSS`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>1: Dead <br>0: Live</span>
            </v-tooltip>
          </template>
          <!-- header.DSS.time slot -->
          <template v-slot:[`header.DSS.time`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Unit: Day</span>
            </v-tooltip>
          </template>
          <!-- header.PFI slot -->
          <template v-slot:[`header.PFI`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>1: Dead <br>0: Live</span>
            </v-tooltip>
          </template>
          <!-- header.PFI.time slot -->
          <template v-slot:[`header.PFI.time`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Unit: Day</span>
            </v-tooltip>
          </template>
          <!-- item.project_id slot -->
          <template v-slot:[`item.project_id`]="{item}">
            {{item.project_id.split('-')[1]}}
          </template>

          <!-- header.data-table-select slot-->
          <template v-slot:[`header.data-table-select`]="{ on, props }">
            <v-simple-checkbox color="success"
                               v-bind="props"
                               v-on="on"></v-simple-checkbox>
          </template>

          <!-- item.data-table-select slot -->
          <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
            <v-simple-checkbox color="info"
                               :value="isSelected"
                               @input="select($event)"></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import JsonExcel from 'vue-json-excel';
import { getTcgaMeta } from "node/projects"
export default {
  name: 'TCGA',
  components: {
    JsonExcel,
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Projects',
          disabled: true,
        },
        {
          text: 'TCGA',
          disabled: false,
          href: '/ascancer/projects/tcga',
        },
        {
          text: this.$route.params.id,
          disabled: true,
        },
      ],
      project_meta: {},
      project_samples: [],
      selectedHeader: ['Sample ID', 'Project ID',
        'Type', 'Gender', 'Stage',
        'Histological Type', 'Hitological Grade',
        'Status', 'Survival Time'],
      search: '',
      selected: [],
      singleSelect: false,
      loading: true,
      itemsPerPage: 15,
      headers: [
        { text: 'Sample ID', value: 'ID', align: 'start', sortable: true, },
        { text: 'Project ID', value: 'project_id', align: 'start', sortable: true, },
        { text: 'Type', value: 'type', align: 'start', },
        { text: 'Gender', value: 'gender', align: 'start', sortable: false, },
        { text: 'Race', value: 'race', align: 'start' },
        { text: 'Stage', value: 'stage', align: 'start' },
        { text: 'Histological Type', value: 'histological_type', align: 'start' },
        { text: 'Histological Grade', value: 'histological_grade', align: 'start' },
        { text: 'Status', value: 'status', align: 'start' },
        { text: 'Survival Time', value: 'time', align: 'start' },
        { text: 'DSS', value: 'DSS', align: 'start' },
        { text: 'DSS Time', value: 'DSS.time', align: 'start' },
        { text: 'DFI', value: 'DFI', align: 'start' },
        { text: 'DFI time', value: 'DFI.time', align: 'start' },
        { text: 'PFI', value: 'PFI', align: 'start' },
        { text: 'PFI time', value: 'PFI.time', align: 'start' }
      ],
    }
  },
  created() {
    this.getTcgaMeta();
  },
  computed: {
    selectedHeaders() {
      return this.headers.filter(h => this.selectedHeader.includes(h.text))
    }
  },
  watch: {
    project_samples(val) {
      if (val) {
        this.loading = false;
      }
    },
  },
  methods: {
    // get all TCGA meta info
    async getTcgaMeta() {
      let id = this.$route.params.id;
      await getTcgaMeta(id).then(
        data => {
          if (data.length > 0) {
            // console.log(data);
            this.project_meta = data[0];
            this.project_samples = data[0].samples;
          } else {
            this.$router.push('/error')
          }
        }
      ).catch(err => console.error(err))
    },
    showAll() {
      this.headers.map(h => {
        this.selectedHeader.push(h.text)
      })
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = ['Sample ID', 'Project ID', 'Type', 'Gender',
        'Stage', 'Histological Type', 'Hitological Grade',
        'Status', 'Survival Time'];
    },
  }
}
</script>
<style scoped lang="sass">
.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-sheet.v-card
  border-radius: 15px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>